export enum DevicePlatform {
    Desktop = "Desktop",
    Tablet = "Tablet",
    Mobile = "Mobile",
}

export interface IDeviceState {
    platform: DevicePlatform;
}
